import { actionGenerator, IReduxAction } from '../../../actionGenerator';
import { ICheckoutInfo } from '../types';

export const CHECK_SERVICE_SUCCESS = 'CHECKOUT_INFO :: CHECK_SERVICE_SUCCESS';

export type TCheckServiceSuccessAction = IReduxAction<typeof CHECK_SERVICE_SUCCESS, ICheckoutInfo>;

export const checkServiceSuccess = actionGenerator<typeof CHECK_SERVICE_SUCCESS, ICheckoutInfo>(CHECK_SERVICE_SUCCESS);
